document.addEventListener('DOMContentLoaded', function() {
  // Find all search sections on the page
  const searchSections = document.querySelectorAll('[id^="shopify-section-"] .search-bar-input-container');
  
  searchSections.forEach(function(section) {
    const searchInput = section.querySelector('input');
    const clearButton = section.querySelector('.search-close-btn');
    const searchButton = section.querySelector('.search-icon-btn');
    
    // Function to perform search
    function performSearch() {
      const searchTerm = searchInput.value.trim();
      if (searchTerm) {
        window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
      }
    }
    
    // Clear button functionality
    if (clearButton && searchInput) {
      clearButton.addEventListener('click', function() {
        searchInput.value = '';
        searchInput.focus();
      });
    }
    
    // Search button functionality
    if (searchButton && searchInput) {
      searchButton.addEventListener('click', function() {
        performSearch();
      });
    }
    
    // Enter key functionality
    if (searchInput) {
      searchInput.addEventListener('keypress', function(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          performSearch();
        }
      });
    }
  });
});
